import styled from 'styled-components';
import { Button } from '../button';
import { Icon } from '../icon';

export const AccordionCard = styled.div`
	display: flex;
	flex-direction: column;
	background: ${p => p.theme.aiChat.card.background};
	border: 1px solid ${p => p.theme.aiChat.card.border};
	border-radius: 4px;
	box-shadow: ${p => p.theme.aiChat.card.shadow};
	overflow: hidden;
	font-family: ${p => p.theme.font};
	width: 100%;
`;

export const AccordionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 14px;
	height: 72px;
	box-sizing: border-box;
	flex-shrink: 0;
`;

export const AccordionHeaderLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const AccordionIconContainer = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 8px;
	background: ${p => p.theme.aiChat.pill.background};
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const AccordionSparkleIcon = styled(Icon)`
	font-size: 20px;
	color: ${p => p.theme.aiChat.pill.color};
`;

export const AccordionTitleGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

export const AccordionTitle = styled.span`
	font-family: ${p => p.theme.font};
	font-size: 14px;
	font-weight: 600;
	color: ${p => p.theme.aiChat.header.title};
	line-height: 1.5;
`;

export const AccordionSubtitle = styled.span`
	font-family: ${p => p.theme.font};
	font-size: 12px;
	color: ${p => p.theme.aiChat.input.placeholder};
	line-height: 1.4;
`;

export const AccordionHeaderRight = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
`;

// Shared by the chevron and the clear-history button — plain ghost icon button.
export const AccordionChevronButton = styled(Button)`
	&& {
		width: 40px;
		height: 40px;
		flex-shrink: 0;
		color: ${p => p.theme.aiChat.input.placeholder};
		background: transparent;
		border: none;

		${Icon.cssSelector} {
			color: inherit;
		}

		&:hover:not(:disabled) {
			color: ${p => p.theme.aiChat.header.title};
			background: ${p => p.theme.aiChat.messageList.background};
		}

		&:focus-visible {
			outline: none;
			box-shadow: ${p => p.theme.aiChat.input.focusShadow};
		}
	}
`;

export const AccordionContentWrapper = styled.div<{ $isOpen: boolean }>`
	display: grid;
	grid-template-rows: ${p => p.$isOpen ? '1fr' : '0fr'};
	transition: grid-template-rows 0.35s ease-in-out;
`;

export const AccordionContentInner = styled.div`
	overflow: hidden;
`;

export const AccordionMessageListWrapper = styled.div<{ $height: string | number }>`
	height: ${p => typeof p.$height === 'number' ? `${p.$height}px` : p.$height};
	display: flex;
	flex-direction: column;
	overflow: hidden;
`;
